<template>
  <div class="basic">
    <el-tabs type="border-card" value="first" class="frame">
      <el-tab-pane class="jbinfo" label="基本信息" name="first">
        <el-form :model="infoForm" label-width="120px">
          <el-row class="yangshi">
            <el-col :span="8">
              <el-form-item label="公司信息:" class="repair">
                <el-button
                  type="primary"
                  round
                  @click="apply"
                  :class="!loadStatus? 'yanse':'yangshi2'"
                  style="outline:none; border: none; "
                >
                  <i class="biaox" :class="!loadStatus? 'userIcon':''"></i>
                  {{!loadStatus?"申请加入":infoForm.custNameCn}}
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户状态:">
                <el-button type="text" style="pointer-events: none;"></el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="平台销售:">
                <el-button type="text" style="pointer-events: none;">{{infoForm.settleOfficeName}}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="yangshi">
            <el-col :span="8">
              <el-form-item label="用户:" class="repair">
                <el-button type="text" style="pointer-events: none;">{{infoForm.userNameCn}}</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号:">
                <el-button type="text" style="pointer-events: none;" @click="phone">
                  {{infoForm.mobilePhone}}
                  <el-tooltip
                    class="item item_sjh"
                    effect="dark"
                    content="修改手机号"
                    placement="top-start"
                  >
                    <i class="alterAs" style="pointer-events: auto;"></i>
                  </el-tooltip>
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="邮箱:">
                <el-button type="text" style="pointer-events: none;" @click="mailbox">
                  {{infoForm.email}}
                  <el-tooltip class="item" effect="dark" content="修改邮箱" placement="top-start">
                    <i class="alterAs" style="pointer-events: auto;"></i>
                  </el-tooltip>
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="yangshi yangshi3">
            <el-col :span="8">
              <el-form-item label="用户状态:" class="repair">
                <el-button
                  type="text"
                  style="pointer-events: none;"
                >{{clientState == '1' ?'生效':"未生效"}}</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户归属状态:">
                <!-- <el-tag class="staBtn" type="warning">{{infoForm.usgSta}}</el-tag> -->
                <i class="affiliationState" v-if="this.operation === '未绑定'"></i>
                <i class="affiliationState2" v-if="this.operation === '待审核'">
                  <span class="state_hint">您已提交加入申请，请联系管理员进行审批！</span>
                </i>
                <i class="affiliationState3" v-if="this.operation === '已绑定'"></i>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <!-- 修改密码 -->

      <el-tab-pane class="changePs" label="修改密码" name="second">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="right"
        >
          <el-form-item label="原始登录密码:" :class="frameShow === 0 ? '':'frame'">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              @blur="checkPass"
              :clearable="true"
              placeholder="输入原始登录密码"
            ></el-input>
            <i class="pass_hint">{{passinfo}}</i>
          </el-form-item>
          <el-form-item label="新登录密码：" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              :clearable="true"
              placeholder="输入新登录密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="confirmpass">
            <el-input
              type="password"
              v-model="ruleForm.confirmpass"
              :clearable="true"
              placeholder="输入新登录密码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="save" type="primary" @click="changePassword">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 用户管理 -->

      <el-tab-pane
        class="management"
        label="用户管理"
        name="third"
        v-if="disableds == '1'? true : false "
      >
        <el-form
          :inline="true"
          :model="userform"
          class="demo-form-inline"
          ref="userform"
          :rules="rules"
        >
          <el-form-item label="用户名：" prop="user" class="chaxun">
            <el-input v-model="userform.user"></el-input>
          </el-form-item>
          <el-form-item label="用户归属状态：" prop="region">
            <el-select v-model="userform.region" placeholder="全部">
              <el-option label="全部" value></el-option>
              <el-option label="待审核" value="20"></el-option>
              <el-option label="已绑定" value="30"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="yhgl_inquire">
            <el-button type="primary" round class="shenqin" @click="dialogFormVisible = true">
              <i class="chucetubiao"></i>
              邀请注册
            </el-button>

            <el-button class="userInquire" round @click="Inquire">查询</el-button>
            <el-button class="userReset" round @click="resetUser">重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 表单 -->
        <el-table
          :data="infoTable.slice((currentPage-1)*PageSize,currentPage*PageSize)"
          style="width: 100%"
          class="control"
        >
          <el-table-column prop="userNameCn" label="用户" width="100"></el-table-column>
          <el-table-column prop="mobilePhone" label="手机号" width="130"></el-table-column>
          <el-table-column prop="email" label="邮箱" width="220px"></el-table-column>
          <el-table-column prop="isActive" label="用户状态" width="100px">
            <template v-slot:default="{row}">
              <i :class="row.isActive === 1 ? 'userState ':'userState2 '"></i>
            </template>
          </el-table-column>
          <el-table-column prop="ownershipStatus" label="用户归属状态" width="130px">
            <template v-slot:default="{row}">
              <i class="affiliationState" v-if="row.userBindStatus === '未绑定'"></i>
              <i class="affiliationState2" v-if="row.userBindStatus === '待审核'"></i>
              <i class="affiliationState3" v-if="row.userBindStatus === '已绑定'"></i>
            </template>
          </el-table-column>
          <el-table-column label="用户角色" width="120px">
            <template slot-scope="{row}" v-if="row.userRoles">
              <span>{{row.userRoles[0].userRole == 1 ?'管理员':'员工'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot:default="{row}">
              <el-tooltip
                class="item"
                effect="dark"
                :content="row.userBindStatus === '已绑定' ? '解除绑定' : '归属审核'"
                placement="top-start"
              >
                <i
                  :class="row.userBindStatus === '已绑定' ? 'unbound' : 'alterAs'"
                  style="outline:none;"
                  @click="affiliation(row)"
                ></i>
              </el-tooltip>
              <el-popover
                popper-class="bubble"
                trigger="click"
                placement="bottom"
                :visible-arrow="false"
              >
                <p class="ppp" @click="open(row)">{{roless === 1 ?"设置员工":'设置管理员'}}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tooltip class="item" effect="dark" content="更改角色" placement="top-start">
                    <i
                      :class="row.userBindStatus === '已绑定' ? 'alterAsw':''"
                      style="outline:none; "
                      @click="alterStaff(row)"
                    ></i>
                  </el-tooltip>
                </div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          class="paging"
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="PageSize"
          layout=" prev, pager, next"
          :total="totalCount"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 申请表单 -->
    <el-dialog title="申请加入公司" :visible.sync="submitCompany" class="applyfor dd ee">
      <el-form :model="amendForm" ref="companyName" :rules="rules">
        <el-form-item label="公司名称：" prop="companyName">
          <el-input placeholder="请输入用户名" v-model="amendForm.companyName" @blur="submitCom"></el-input>
          <i class="hint" v-if="this.hintName === 1">公司已存在，需要管理员审批加入</i>
          <i class="hint" v-if="this.hintName === 2">公司已存在但无管理员，请联系客服处理</i>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitCompany = false">取 消</el-button>
        <el-button type="primary" @click="sutCom">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 修改手机号 -->
    <el-dialog title="修改手机号码" :visible.sync="mobilefo" class="applyfor ee">
      <el-form :model="amendForm" :rules="rules" ref="companyCellphone" status-icon>
        <el-form-item label="手机号码：" prop="companyCellphone">
          <el-input v-model="amendForm.companyCellphone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mobilefo = false">取 消</el-button>
        <el-button type="primary" @click="alterNumber">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 修改邮箱 -->
    <el-dialog title="修改邮箱" :visible.sync="postboxfo" class="applyfor ews ee">
      <el-form :model="amendForm" :rules="rules" ref="companyImail" status-icon>
        <el-form-item label="设置邮箱：" prop="companyImail">
          <el-input v-model="amendForm.companyImail" placeholder="请输入邮箱"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="postboxfo = false">取 消</el-button>
        <el-button type="primary" @click="alterMailbox">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 邀请注册表单 -->
    <el-dialog
      custom-class="invite_dialog__header"
      title="邀请注册"
      :visible.sync="dialogFormVisible"
      width="410px"
      :before-close="handleClose"
    >
      <el-form :model="inviteForm" :rules="rules" ref="inviteForm" status-icon>
        <el-form-item label="姓名" class="invite_name" :label-width="formLabelWidth" prop="name">
          <el-input v-model="inviteForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号码"
          class="invite_mobile"
          :label-width="formLabelWidth"
          prop="mobile"
        >
          <el-input v-model="inviteForm.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱"
          class="invite_mailbox"
          :label-width="formLabelWidth"
          prop="mailbox"
        >
          <el-input v-model="inviteForm.mailbox" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer invite_dialog_footer">
        <el-button type="primary" @click="sendInvite(inviteForm)">发送邀请</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    // 修改密码

    var validatePass2 = (rule, value, callback) => {
      var regPassword = /^.*(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])\w{5,30}/;
      if (!value) {
        callback(new Error("请输入新密码"));
      } else if (!regPassword.test(value)) {
        callback(new Error("密码必须包含6到30位大小写字母、数字"));
      } else {
        callback();
      }
    };
    let validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (value !== this.ruleForm.checkPass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    //手机号正则
    var validatePass4 = (rule, value, callback) => {
      var regPassword = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!regPassword.test(value)) {
        callback(new Error("请输入正确格式的手机号"));
      } else if (rule.field == "mobile") {
        // this.axios({
        //   method: "get",
        //   url: this.apiUrl + "/bnwl_user_business/sysUser/checkUser",
        //   timeout: 60000,
        //   responseType: "json",
        //   params: {
        //     mobilePhone: this.inviteForm.mobile
        //   }
        // }).then(function(response) {
        //   if (response.data.msg == "OKUY") {
        //     callback(new Error("手机号码已注册"));
        //   } else {
        //     callback();
        //   }
        // });
      } else {
        callback();
      }
    };
    //修改邮箱
    var validatePass5 = (rule, value, callback) => {
      var regPassword = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
      if (!value) {
        callback(new Error("请输入邮箱"));
      } else if (!regPassword.test(value)) {
        callback(new Error("请输入正确格式的邮箱"));
      } else {
        callback();
      }
    };
    return {
      formLabelWidth: "80px",
      dialogFormVisible: false, //邀请加入
      OKCY: "",
      hint: "",
      hint2: "",
      roless: "",
      setAdministrator: 0,
      disableds: "",
      userRoles: [], //用户角色
      frameShow: 0, //显示框
      hintName: 0, //显示提示
      pass_hint: 0, //显示密码提示
      id: "12",
      currentPage: 1, //默认开始页面
      totalCount: 1, //总条数
      PageSize: 5, //每页的数据条数
      passinfo: "",
      clientState: "", //客户状态
      submitCompany: false,
      pop: false,
      mobilefo: false,
      postboxfo: false,
      infoForm: {},
      // 修改弹框
      amendForm: {
        companyName: "",
        companyCellphone: "",
        companyImail: ""
      },
      infoTable: [
        {
          company: "千叶县农产品贸易有限公司",
          companyCode: "",
          createTime: "2020-04-10 10:37:01",
          dataAuthorityId: "",
          dataAuthorityName: "",
          defaultOffice: "CU1016",
          defaultOfficeName: "千叶县农产品贸易有限公司",
          email: "eric.he@worldex.com.cn",
          inserviceStatus: "1",
          isActive: "Y",
          isDeleted: "N",
          isPasswordModify: "Y",
          lastModifyOffice: "EIMSKIP",
          lastModifyOfficeName: "青岛怡之航物流有限公司",
          lastModifyTime: "2020-07-30 11:34:50",
          lastModifyor: "admin",
          lastModifyorName: "系统管理员",
          mobilePhone: "13671911312",
          ownershipStatus: "30",
          password: "e267cfcd18461ce938067eca67c59f41",
          passwordModifyTime: "20200730113450",
          recordVersion: 21,
          roleCode: "CUSM",
          roleName: "客户管理员",
          rowStatus: 2,
          salesCode: "",
          sysRoleId: "4298a23ac4f9439cbdba09650b8bcee3",
          sysUserId: "a51b571884904eec989c2afa2fffb114",
          userDomain: "8",
          userName: "13918333019",
          userNameCn: "蔡小林",
          userType: "10"
        }
      ],
      loadStatus: "",
      operation: "10",
      ruleForm: {
        pass: "",
        checkPass: "",
        confirmpass: ""
      },
      userform: {
        //查询
        user: "", //用户
        region: "" //归属状态
      },
      inviteForm: {
        name: "", //姓名
        mobile: "", //手机
        mailbox: "" //邮箱
      },
      rules: {
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        confirmpass: [{ validator: validatePass3, trigger: "blur" }],
        companyName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: ["blur", "change"]
          }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: ["blur", "change"] }
        ],
        mobile: [{ required: true, validator: validatePass4, trigger: "blur" }],
        mailbox: [
          { required: true, validator: validatePass5, trigger: "blur" }
        ],
        companyCellphone: [{ validator: validatePass4, trigger: "blur" }],
        companyImail: [{ validator: validatePass5, trigger: "blur" }]
      },

      usercontrol: []
    };
  },
  methods: {
    // 密码后台校验
    checkPass(val) {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      var patrn = /^.*(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])\w{5,30}/;
      if (this.ruleForm.pass === "") {
        this.passinfo = "请输入密码";
        this.frameShow = 1;
        return;
      } else if (!patrn.test(this.ruleForm.pass)) {
        this.passinfo = "原始密码错误";
        this.frameShow = 1;
        return;
      }
      this.frameShow = 0;
      console.log(len);
      let that = this;
      let data = {};
      data.userDomainCode = len.userDomainCode;
      data.userAccountName = len.userAccountName;
      data.password = this.ruleForm.pass;
      let response = that.apiService
        .post("/sinoslog-ops-service/user/checkUserPassword", data)
        .then(res => {
          if (res.data.data == false) {
            this.passinfo = "原始密码错误";
            this.frameShow = 1;
          } else {
            this.passinfo = "";
          }
        });
    },
    //用户管理
    async postUserList() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      var self = this;
      let params = {};
      params.opsCustId = len.opsCustId;
      params.userDomainCode = len.userDomainCode;
      let response = await this.apiService
        .get("/sinoslog-ops-service/user/getUserManagerAndCustomerInfo", {
          params
        })
        .then(res => {
          if (res.data.data.msg === "success" && res.data.success == true) {
            this.infoTable = res.data.data.data;
            this.totalCount = res.data.data.data.length;
          }
        });
    },
    //弹框出现
    apply() {
      this.submitCompany = true;
    },
    // 验证加入
    submitCom() {
      var that = this;
      if (!that.amendForm.companyName) {
        that.hintName = 0;
      }
      that.$refs.companyName.validate(valid => {
        if (!valid) return false;
        let params = {};
        params.customerName = this.amendForm.companyName;
        let response = that.apiService
          .get("/sinoslog-ops-service/user/customerName", { params })
          .then(res => {
            if (res.data.success == true) {
              if (res.data.data.data == "已注册") {
                that.Customers();
                return false;
              } else {
                that.hintName = 0;
                return false;
              }
            }
          });
      });
    },
    //客商校验
    async Customers() {
      let that = this;
      let params = {};
      if (this.infoForm.custNameCn) {
        this.amendForm.companyName = this.infoForm.custNameCn;
      }
      params.customerName = this.amendForm.companyName;
      let response = await that.apiService
        .get("/sinoslog-ops-service/user/queryAdminByCustomerName", {
          params
        })
        .then(res => {
          if (res.data.data.data > 0) {
            that.hintName = 1;
          } else if (res.data.data.data < 1) {
            that.hintName = 2;
          }
          return res.data.data;
        });
      return response;
    },
    // 申请加入
    sutCom() {
      // let len = JSON.parse(localStorage.getItem("userInfo"));
      // var that = this;
      // that.$refs.companyName.validate(valid => {
      //   if (!valid) return false;
      //   that
      //     .axios({
      //       method: "post",
      //       url: that.apiUrl + "/bnwl_user_business/sysUser/companyApply",
      //       timeout: 60000,
      //       responseType: "json",
      //       data: {
      //         sysUserId: len.userId,
      //         company: this.amendForm.companyName
      //       }
      //     })
      //     .then(res => {
      //       this.getUserList();
      //       this.postUserList();
      //     });
      // });
      // this.submitCompany = false;
    },
    resetUser() {
      // 获取到表单组件，调用重置表单的方法
      this.$refs.userform.resetFields();
    },

    //更改角色
    async open(val) {
      var that = this;
      let res = await this.Customers();
      if (res.data == 1 && val.userRoles[0].userRole == "1") {
        this.$alert(
          "您是唯一管理员，请先将其他用户设为“管理员”后再“更改角色”",
          "权限更改确认",
          {
            confirmButtonText: "确定",
            customClass: "specialse",
            callback: action => {
              return false;
            }
          }
        );
      } else {
        this.$confirm(
          `您正在将“${val.userNameCn}”的用户角色由“${this.hint2}”更改为“${this.hint}”，请确认是否继续！`,
          "权限更改确认",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "special"
          }
        )
          .then(() => {
            var self = this;
            let cats = "";
            if (val.userRoles[0].userRole == 1) {
              cats = 2;
            } else {
              cats = 1;
            }
            let data = {};
            data.userDomainCode = val.userDomainCode;
            data.userRole = cats;
            data.opsUserRoleId = val.userRoles[0].opsUserRoleId;
            let response = this.apiService
              .post("/sinoslog-ops-service/user/modifyUserInfo", data)
              .then(res => {
                console.log(res);
                this.getUserList();
                this.postUserList();
                this.pop = false;
              });
          })
          .catch(() => {
            this.getUserList();
            this.postUserList();
            this.pop = false;
          });
      }
    },
    alterStaff(row) {
      if (row.userRoles[0].userRole === 1) {
        this.hint = "客户员工";
        this.hint2 = "客户管理员";
      } else {
        this.hint = "客户管理员";
        this.hint2 = "客户员工";
      }
      this.roless = row.userRoles[0].userRole;
    },
    // 归属弹框
    async affiliation(val) {
      var that = this;
      if (val.userBindStatus == "已绑定") {
        let res = await this.Customers();
        if (res.data == 1 && val.userRoles[0].userRole == "1") {
          this.$alert(
            "您是唯一管理员，请先将其他用户设为“管理员”后再“解绑”",
            "解绑提示",
            {
              confirmButtonText: "确定",
              customClass: "specials",
              callback: action => {
                return false;
              }
            }
          );
        } else {
          this.$confirm(
            `您正在解除“${val.userNameCn}”与“${this.infoForm.custNameCn}”的绑定关系，请确认是否继续！`,
            "解除绑定确认",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "special"
            }
          )
            .then(() => {
              let data = {};
              data.userBindStatus = "未绑定";
              data.opsUserId = val.opsUserId;
              let res = this.message(data);
              res.then(res => {
                if (res == "success") {
                  this.getUserList();
                  this.postUserList();
                }
              });
            })
            .catch(() => {});
        }
      } else {
        this.$confirm(
          `用户“${val.userNameCn}”已注册并提交申请成为贵公司名下用户，请审批是否通过！`,
          "归属审核确认",
          {
            confirmButtonText: "通过",
            cancelButtonText: "驳回",
            customClass: "special"
          }
        )
          .then(() => {
            let data = {};
            data.userBindStatus = "已绑定";
            data.opsUserId = val.opsUserId;
            let res = this.message(data);
            res.then(res => {
              if (res == "success") {
                this.getUserList();
                this.postUserList();
              }
            });
          })
          .catch(() => {
            let data = {};
            data.userBindStatus = "未绑定";
            data.opsUserId = val.opsUserId;
            let res = this.message(data);
            res.then(res => {
              if (res == "success") {
                this.getUserList();
                this.postUserList();
              }
            });
            //   that
            //     .axios({
            //       method: "post",
            //       url: that.apiUrl + "/bnwl_user_business/sysUser/companyUnbind",
            //       timeout: 60000,
            //       responseType: "json",
            //       data: {
            //         sysUserId: val.sysUserId,
            //         company: val.company
            //       }
            //     })
            //     .then(res => {
            //       if (val.roleName === "客户管理员") {
            //         window.location.reload();
            //         this.getUserList();
            //         this.postUserList();
            //       } else {
            //         this.getUserList();
            //         this.postUserList();
            //       }
            //     });
          });
      }
    },
    //修改手机弹框
    phone(row) {
      this.mobilefo = true;
    },
    // 保存修改手机号
    alterNumber() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      this.$refs.companyCellphone.validate(valid => {
        if (!valid) return false;
        let data = {};
        data.mobilePhone = this.amendForm.companyCellphone;
        let res = this.message(data);
        res.then(res => {
          if (res == "success") {
            this.infoForm.mobilePhone = this.amendForm.companyCellphone;
          }
        });
        this.mobilefo = false;
      });
    },
    resetUser() {
      // 获取到表单组件，调用重置表单的方法
      // this.$refs.userform.resetFields();
    },
    // 邮箱弹框
    mailbox(row) {
      this.postboxfo = true;
    },
    //邮箱保存
    async alterMailbox() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      await this.$refs.companyImail.validate(valid => {
        if (!valid) return false;
        let that = this;
        let data = {};
        data.email = this.amendForm.companyImail;
        let res = this.message(data);
        res.then(res => {
          if (res == "success") {
            this.infoForm.email = this.amendForm.companyImail;
          }
        });
        this.postboxfo = false;
      });
    },
    resetUser() {
      // 获取到表单组件，调用重置表单的方法
      // this.$refs.userform.resetFields();
    },
    //保存密码
    changePassword() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      if (this.ruleForm.pass === "") {
        this.passinfo = "请输入密码";
        this.frameShow = 1;
        return;
      }
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return false;
        let that = this;
        let data = {};
        data.password = this.ruleForm.checkPass;
        let res = this.message(data);
        res.then(res => {
          if (res == "success") {
            this.ruleForm.pass = "";
            this.$refs.ruleForm.resetFields(); //清空
            this.$message({
              showClose: true,
              customClass: "tank",
              message: "密码修改成功",
              type: "success",
              offset: 300,
              duration: 2000
            });
          }
        });
      });
    },
    //查询
    Inquire() {
      // let that = this;
      // if (this.userform.user) {
      //   this.pagenum = 1;
      //   this.postUserList();
      // } else {
      //   this.postUserList();
      // }
    },
    handleCurrentChange(val) {
      // 修改了当前页
      // this.currentPage = val;
      // this.postUserList();
    },
    // 用戶信息接口
    async message(val) {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      let that = this;
      let data = val;
      if (!data.opsUserId) {
        data.opsUserId = len.opsUserId;
      }
      // data.userDomainCode = "";
      // data.userAccountName = "";
      // data.password = "";
      // data.userNameEn = "";
      // data.mobilePhone = this.amendForm.companyCellphone;
      // data.email = this.amendForm.companyImail;
      // data.userBindStatus = "";
      let response = await that.apiService
        .post("/sinoslog-ops-service/user/modifyUserInfo", data)
        .then(res => {
          return res.data;
        });
      return response;
    },

    //基本信息
    async getUserList() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      let self = this;
      let params = {};
      params.opsUserId = len.opsUserId;
      params.userDomainCode = len.userDomainCode;
      let response = await this.apiService
        .get("/sinoslog-ops-service/user/getUserAndCustomerInfo", {
          params
        })
        .then(res => {
          if (res.data.data.msg === "success") {
            localStorage.setItem(
              "userInfo",
              JSON.stringify(res.data.data.data)
            ); //用户信息
            this.infoForm = res.data.data.data;
            this.operation = res.data.data.data.userBindStatus;
            this.clientState = res.data.data.data.isActive;
            this.loadStatus = res.data.data.data.custNameCn;
            this.disableds = res.data.data.data.userRoles[0].userRole;
            if (this.disableds == 1) {
              this.postUserList();
            }
          }
        });
    },
    // 发送邀请
    sendInvite(val) {
      this.dialogFormVisible = false;
      this.$router.push({ name: "Invite" });
    },
    handleClose() {
      this.$refs.inviteForm.resetFields();
      this.dialogFormVisible = false;
    }
  },

  created: function() {
    this.getUserList();
  }
};
</script>


<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>


<style scoped>
.basic_monicker {
  color: #aaa;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/steward/account.vue